var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3567_5537)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 12.8464C27 12.5258 26.8726 12.2183 26.646 11.9916C26.4193 11.765 26.1118 11.6376 25.7912 11.6376H23.3737L21.5606 9.22009H16.7255L14.9124 11.6376H12.4949C12.1743 11.6376 11.8669 11.765 11.6402 11.9916C11.4135 12.2183 11.2861 12.5258 11.2861 12.8464V20.0989C11.2861 20.4195 11.4135 20.727 11.6402 20.9536C11.8669 21.1803 12.1743 21.3077 12.4949 21.3077H25.7912C26.1118 21.3077 26.4193 21.1803 26.646 20.9536C26.8726 20.727 27 20.4195 27 20.0989V12.8464Z",
    stroke: "black",
    strokeWidth: 1.20876,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1426 18.5879C19.8639 18.5879 20.5556 18.3014 21.0657 17.7914C21.5757 17.2813 21.8623 16.5895 21.8623 15.8682C21.8623 15.1469 21.5757 14.4552 21.0657 13.9451C20.5556 13.4351 19.8639 13.1485 19.1426 13.1485C18.4212 13.1485 17.7295 13.4351 17.2194 13.9451C16.7094 14.4552 16.4229 15.1469 16.4229 15.8682C16.4229 16.5895 16.7094 17.2813 17.2194 17.7914C17.7295 18.3014 18.4212 18.5879 19.1426 18.5879Z",
    stroke: "black",
    strokeWidth: 1.20876,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3567_5537",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3567_5537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3567_5537",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.a390a2d0060b5207dab31da360e25106.svg";
export { ForwardRef as ReactComponent };